import { DEFAULT_HEARTBEAT } from "./constants";
export function heartbeat(ws, lastMessageTime, options) {
    const { interval = DEFAULT_HEARTBEAT.interval, timeout = DEFAULT_HEARTBEAT.timeout, message = DEFAULT_HEARTBEAT.message, } = options || {};
    const heartbeatInterval = setInterval(() => {
        if (lastMessageTime.current + timeout <= Date.now()) {
            console.warn(`Heartbeat timed out, closing connection, last message was seen ${Date.now() - lastMessageTime.current}ms ago`);
            ws.close();
        }
        else {
            if (lastMessageTime.current + interval <= Date.now()) {
                try {
                    if (typeof message === 'function') {
                        ws.send(message());
                    }
                    else {
                        ws.send(message);
                    }
                }
                catch (err) {
                    console.error(`Heartbeat failed, closing connection`, err instanceof Error ? err.message : err);
                    ws.close();
                }
            }
        }
    }, interval);
    ws.addEventListener("close", () => {
        clearInterval(heartbeatInterval);
    });
    return () => { };
}
//# sourceMappingURL=heartbeat.js.map